import SAR from "components/Sar/SAR"
import { useLang } from "hooks/useLang"

interface IProps {
    price: number
    // currency?: string
    className?: string
    color?: string
}

const PriceComponent = ({ price, className, color = "white" }: IProps) => {
    const { t } = useLang()
    return (
        <div className={className}>
            {price === 0 ? (
                <span>{t("free_tickets")}</span>
            ) : (
                <SAR width={16} height={16} price={price} color={color} />
            )}
        </div>
    )
}
export default PriceComponent
